import tippy, { hideAll } from "tippy.js";

export default (value = "") => ({
  tippyInstance: null,
  open: false,
  value: value,
  listbox: null,
  options: [],
  closedByEscape: false,

  init() {
    this.initTippy();

    const selectedOption = this.$root.querySelector(
      `[data-value="${this.value}"]`
    );
    if (selectedOption) {
      this.$refs.buttonContent.innerHTML = selectedOption.innerHTML;
    }
  },

  initTippy() {
    const _this = this;
    const $refs = this.$refs;
    this.tippyInstance = tippy($refs.button, {
      arrow: false,
      role: "dropdown",
      content: $refs.content.innerHTML,
      allowHTML: true,
      interactive: true,
      maxWidth: "100%",
      placement: "bottom-start",
      trigger: "click",
      popperOptions: {
        modifiers: [
          {
            name: "sameWidth",
            enabled: true,
            fn: ({ state }) => {
              state.styles.popper.width = `${state.rects.reference.width}px`;
            },
            phase: "beforeWrite",
            requires: ["computeStyles"],
            effect: ({ state }) => {
              state.elements.popper.style.width = `${state.elements.reference.clientWidth}px`;
            },
          },
        ],
      },
      onShow(instance) {
        _this.open = true;
        hideAll({ exclude: instance });
      },
      onShown(instance) {
        let listbox = instance.popper.querySelector('[role="listbox"]');
        if (listbox) {
          _this.listbox = listbox;
          _this.options = Array.from(
            listbox.querySelectorAll('[role="option"]')
          );
          listbox.focus();
        }
      },
      onHide() {
        _this.open = false;
      },
      onHidden() {
        if (_this.closedByEscape) {
          _this.$refs.button.focus();
          _this.closedByEscape = false;
        }
      },
    });
  },

  selectOption() {
    this.value = this.$event.currentTarget.getAttribute("data-value");
    this.$refs.buttonContent.innerHTML = this.$event.currentTarget.innerHTML;
    this.hide();
  },

  hide() {
    this.tippyInstance.hide();
  },

  handleKeyDown() {
    if (!this.listbox.getAttribute("aria-expanded") === "true") {
      return;
    }

    if (this.options.length === 0) {
      return;
    }

    let key = this.$event.key;
    if (key === " ") {
      key = "Space";
    }

    if (key == "Escape") {
      this.closedByEscape = true;
      this.hide();
      return;
    }

    if (key == "Tab") {
      this.hide();
      return;
    }

    const hasActiveElement = this.options.includes(document.activeElement);
    const isDownArrow = key == "ArrowDown";
    const isUpArrow = key == "ArrowUp";

    if (isDownArrow) {
      this.$event.preventDefault();

      if (!hasActiveElement) {
        this.options[0].focus();
        return;
      }

      if (document.activeElement.nextElementSibling) {
        document.activeElement.nextElementSibling.focus();
      }
    }

    if (isUpArrow) {
      this.$event.preventDefault();

      if (!hasActiveElement) {
        this.options[this.options.length - 1].focus();
        return;
      }

      if (document.activeElement.previousElementSibling) {
        document.activeElement.previousElementSibling.focus();
      }
    }
  },
});
